module.exports = __webpack_public_path__ + "static/media/optimization.a7934754.svg";